import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core'; // sau ce folosești
import { MenuItem } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private translateService = inject(TranslateService);

  private readonly navigationItems = signal([
    {
      label: this.translateService.instant('app.navigation.dashboard'),
      icon: 'pi pi-th-large',
      routerLink: '/dashboard',
    },
    {
      label: this.translateService.instant('app.navigation.clients'),
      icon: 'pi pi-users',
      routerLink: '/clients',
    },
    {
      label: this.translateService.instant('app.navigation.invitations'),
      icon: 'pi pi-envelope',
      routerLink: '/invitations',
    },
    {
      label: this.translateService.instant('app.navigation.administration'),
      icon: 'pi pi-cog',
      expanded: true,
      items: [
        {
          label: this.translateService.instant('app.navigation.organization'),
          icon: 'pi pi-building',
          routerLink: '/administration/organization',
        },
        {
          label: this.translateService.instant('app.navigation.users'),
          icon: 'pi pi-user',
          routerLink: '/administration/users',
        },
        {
          label: this.translateService.instant('app.navigation.settings'),
          icon: 'pi pi-user',
          routerLink: '/administration/settings',
        },
      ],
    },
  ]);

  getNavigationMenuItems(): WritableSignal<MenuItem[]> {
    return this.navigationItems;
  }
}
